import React from 'react';
import styled from 'styled-components';
import { Platform } from 'types/platform';
import img1 from 'assets/platforms/music.vk.com.png';
import img2 from 'assets/platforms/zvuk.com.png';
import img3 from 'assets/platforms/hungama.com.png';
import img5 from 'assets/platforms/jaxsta.com.png';
import img6 from 'assets/platforms/imusica.com.br.png';
import img7 from 'assets/platforms/music.apple.com.png';
import img8 from 'assets/platforms/pandora.com.png';
import img9 from 'assets/platforms/anghami.com.png';
import img10 from 'assets/platforms/mixupload.com.png';
import img11 from 'assets/platforms/xbox.com.png';
import img12 from 'assets/platforms/itunes.apple.com.png';
import img13 from 'assets/platforms/beatport.com.png';
import img14 from 'assets/platforms/shazam.com.png';
import img15 from 'assets/platforms/youtube.com.png';
import img16 from 'assets/platforms/7digital.com.png';
import img17 from 'assets/platforms/amazon.com.png';
import img18 from 'assets/platforms/amientertainment.com.png';
import img20 from 'assets/platforms/awa.fm.png';
import img21 from 'assets/platforms/bmat.com.png';
import img22 from 'assets/platforms/flo.com.png';
import img23 from 'assets/platforms/facebook.com.png';
import img24 from 'assets/platforms/roxymusic.co.uk.png';
import img25 from 'assets/platforms/qobuz.com.png';
import img28 from 'assets/platforms/nuuday.com.png';
import img29 from 'assets/platforms/music.163.com.png';
import img30 from 'assets/platforms/napster.com.png';
import img32 from 'assets/platforms/mixcloud.com.png';
import img33 from 'assets/platforms/meplaylist.com.png';
import img36 from 'assets/platforms/lickd.com.png';
import img37 from 'assets/platforms/kuackmedia.com.png';
import img38 from 'assets/platforms/kkbox.com.png';
import img39 from 'assets/platforms/joox.com.png';
import img40 from 'assets/platforms/jiosaavn.com.png';
import img41 from 'assets/platforms/iheart.com.png';
import img43 from 'assets/platforms/fizy.com.png';
import img44 from 'assets/platforms/xite.com.png';
import img45 from 'assets/platforms/touchtunes.com.png';
import img46 from 'assets/platforms/trebel.io.png';
import img47 from 'assets/platforms/tidal.com.png';
import img48 from 'assets/platforms/tencent.com.png';
import img49 from 'assets/platforms/pretzel.rocks.png';
import img53 from 'assets/platforms/nightlife.com.au.png';
import img54 from 'assets/platforms/music.youtube.com.png';
import img55 from 'assets/platforms/boomplay.com.png';
import img57 from 'assets/platforms/spotify.com.png';
import img64 from 'assets/platforms/music.yandex.ru.png';
import img65 from 'assets/platforms/deezer.com.png';
import img66 from 'assets/platforms/tiktok.com.png';
import img67 from 'assets/platforms/audiomack.com.png';


const platformMap: Record<number, string> = {
  1: img1,
  2: img2,
  3: img3,
  5: img5,
  6: img6,
  7: img7,
  8: img8,
  9: img9,
  10: img10,
  11: img11,
  12: img12,
  13: img13,
  14: img14,
  15: img15,
  16: img16,
  17: img17,
  18: img18,
  20: img20,
  21: img21,
  22: img22,
  23: img23,
  24: img24,
  25: img25,
  28: img28,
  29: img29,
  30: img30,
  32: img32,
  33: img33,
  36: img36,
  37: img37,
  38: img38,
  39: img39,
  40: img40,
  41: img41,
  43: img43,
  44: img44,
  45: img45,
  46: img46,
  47: img47,
  48: img48,
  49: img49,
  53: img53,
  54: img54,
  55: img55,
  57: img57,
  64: img64,
  65: img65,
  66: img66,
  67: img67
};

interface PlatformProps {
  platforms: Platform[];
}

export const Platforms: React.FC<PlatformProps> = props => {
  
  return (
    <Container>
      {props.platforms.map((platform) => {
        const icon = platformMap[Number(platform.id)];

        if (icon) {
          return <Icon src={icon} />;
        }
       return platform.name;
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 4px;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
`;

const Icon = styled.div<{ src: string }>`
  height: 21px;
  width: 21px;
  border-radius: 4px;
  background-size: cover;
  background-position: center;
  background-image: url("${props => props.src}");
`;

// {
//     "success": true,
//     "data": [
//         {
//             "id": 1,
//             "name": "VK Music"
//         },
//         {
//             "id": 2,
//             "name": "Zvuk"
//         },
//         {
//             "id": 3,
//             "name": "Hungama"
//         },
//         {
//             "id": 4,
//             "name": "Hungama Video"
//         },
//         {
//             "id": 5,
//             "name": "Jaxsta Music"
//         },
//         {
//             "id": 6,
//             "name": "iMusica"
//         },
//         {
//             "id": 7,
//             "name": "Apple Music"
//         },
//         {
//             "id": 8,
//             "name": "Pandora"
//         },
//         {
//             "id": 9,
//             "name": "Anghami"
//         },
//         {
//             "id": 10,
//             "name": "MixUpload"
//         },
//         {
//             "id": 11,
//             "name": "Microsoft (Xbox, Zune"
//         },
//         {
//             "id": 12,
//             "name": "iTunes Music Store"
//         },
//         {
//             "id": 13,
//             "name": "Beatport"
//         },
//         {
//             "id": 14,
//             "name": "Shazam"
//         },
//         {
//             "id": 15,
//             "name": "YouTube Video"
//         },
//         {
//             "id": 16,
//             "name": "7Digital"
//         },
//         {
//             "id": 17,
//             "name": "Amazon"
//         },
//         {
//             "id": 18,
//             "name": "Ami Entertainment"
//         },
//         {
//             "id": 19,
//             "name": "AudibleMagic"
//         },
//         {
//             "id": 20,
//             "name": "AWA"
//         },
//         {
//             "id": 21,
//             "name": "Bmat"
//         },
//         {
//             "id": 22,
//             "name": "Dreamus Company (FLO)"
//         },
//         {
//             "id": 23,
//             "name": "Facebook Video Finger"
//         },
//         {
//             "id": 24,
//             "name": "Roxi Music Videos"
//         },
//         {
//             "id": 25,
//             "name": "Qobuz"
//         },
//         {
//             "id": 26,
//             "name": "Phononet"
//         },
//         {
//             "id": 27,
//             "name": "Peloton"
//         },
//         {
//             "id": 28,
//             "name": "Nuuday A\/S"
//         },
//         {
//             "id": 29,
//             "name": "NetEase Cloud Music"
//         },
//         {
//             "id": 30,
//             "name": "Napster"
//         },
//         {
//             "id": 31,
//             "name": "Muska"
//         },
//         {
//             "id": 32,
//             "name": "Mixcloud"
//         },
//         {
//             "id": 33,
//             "name": "MePlaylist"
//         },
//         {
//             "id": 34,
//             "name": "LyricFind"
//         },
//         {
//             "id": 35,
//             "name": "LINE Music"
//         },
//         {
//             "id": 36,
//             "name": "Lickd"
//         },
//         {
//             "id": 37,
//             "name": "Kuack Media"
//         },
//         {
//             "id": 38,
//             "name": "KkBox"
//         },
//         {
//             "id": 39,
//             "name": "Joox"
//         },
//         {
//             "id": 40,
//             "name": "JioSaavn"
//         },
//         {
//             "id": 41,
//             "name": "iHeartRadio"
//         },
//         {
//             "id": 42,
//             "name": "Gracenote"
//         },
//         {
//             "id": 43,
//             "name": "fizy"
//         },
//         {
//             "id": 44,
//             "name": "Xite"
//         },
//         {
//             "id": 45,
//             "name": "TouchTunes \/ PlayNetw"
//         },
//         {
//             "id": 46,
//             "name": "Trebel Music"
//         },
//         {
//             "id": 47,
//             "name": "TIDAL"
//         },
//         {
//             "id": 48,
//             "name": "Tencent"
//         },
//         {
//             "id": 49,
//             "name": "Pretzel Rocks"
//         },
//         {
//             "id": 50,
//             "name": "Digital Stores"
//         },
//         {
//             "id": 51,
//             "name": "Anghami Video"
//         },
//         {
//             "id": 52,
//             "name": "Apple Video"
//         },
//         {
//             "id": 53,
//             "name": "Nightlife Music"
//         },
//         {
//             "id": 54,
//             "name": "YouTube Music"
//         },
//         {
//             "id": 55,
//             "name": "Boomplay"
//         },
//         {
//             "id": 56,
//             "name": "Boomplay Video"
//         },
//         {
//             "id": 57,
//             "name": "Spotify"
//         },
//         {
//             "id": 58,
//             "name": "Yandex.Video"
//         },
//         {
//             "id": 59,
//             "name": "Facebook Video"
//         },
//         {
//             "id": 60,
//             "name": "Amazon Video"
//         },
//         {
//             "id": 61,
//             "name": "TIDAL Video"
//         },
//         {
//             "id": 62,
//             "name": "VK Video"
//         },
//         {
//             "id": 63,
//             "name": "fizy Video"
//         },
//         {
//             "id": 64,
//             "name": "Yandex.Music"
//         },
//         {
//             "id": 65,
//             "name": "Deezer"
//         },
//         {
//             "id": 66,
//             "name": "TikTok Music"
//         },
//         {
//             "id": 67,
//             "name": "AudioMack"
//         }
//     ]
// }
